import { render, staticRenderFns } from "./shareholderMeeting.vue?vue&type=template&id=5fd084cf&scoped=true"
import script from "./shareholderMeeting.vue?vue&type=script&lang=js"
export * from "./shareholderMeeting.vue?vue&type=script&lang=js"
import style0 from "./shareholderMeeting.vue?vue&type=style&index=0&id=5fd084cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd084cf",
  null
  
)

export default component.exports